var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    { staticClass: "h-full", class: { "large-font-mode": _vm.largeFontMode } },
    [
      _c("el-main", { staticStyle: { height: "100%" } }, [
        _c(
          "div",
          { staticClass: "flex flex-row h-full" },
          [
            _c(
              "el-card",
              { staticClass: "register-con self-stretch" },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex flex-col cursor-pointer",
                    on: { click: _vm.enroll },
                  },
                  [
                    _c("img", {
                      staticClass: "register-logo",
                      attrs: {
                        src: require("@/assets/treatment/register.png"),
                        alt: "",
                      },
                    }),
                  ]
                ),
                _c("patients", {
                  ref: "patients",
                  staticStyle: { width: "176px" },
                }),
              ],
              1
            ),
            _vm.activePatientInfo && Object.keys(_vm.activePatientInfo).length
              ? _c(
                  "div",
                  {
                    staticClass: "treatment-con",
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                      height: "100%",
                    },
                  },
                  [
                    _c(
                      "el-card",
                      [
                        [
                          _c("div", { staticClass: "patient-header" }, [
                            _c("div", { staticClass: "header-left" }, [
                              _c("img", {
                                staticClass: "header-avatar",
                                attrs: {
                                  src: require("@/assets/treatment/profile-img.png"),
                                  alt: "头像",
                                },
                              }),
                              _c("div", { staticClass: "header-info" }, [
                                _c(
                                  "div",
                                  { staticClass: "info-row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "patient-name" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.activePatientInfo.name || "-"
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "patient-meta" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.activePatientInfo.sexSign ===
                                              "1"
                                              ? "男"
                                              : "女"
                                          ) +
                                            "/" +
                                            _vm._s(
                                              _vm.calculateAge(
                                                _vm.activePatientInfo.birthDate
                                              )
                                            ) +
                                            "岁"
                                        ),
                                      ]
                                    ),
                                    _vm.tizhi &&
                                    Object.keys(_vm.tizhi).length > 0
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.getTizhiType(),
                                              size: "small",
                                              effect: "dark",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-first-aid-kit",
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.getTizhiText()) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "info",
                                              size: "small",
                                              effect: "plain",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                            }),
                                            _vm._v(" 未辨识 "),
                                          ]
                                        ),
                                    _c(
                                      "span",
                                      { staticClass: "patient-phone" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.activePatientInfo
                                              .contactPhone || "-"
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm.activePatientInfo.label ||
                                _vm.activePatientInfo.patientRemark
                                  ? _c(
                                      "div",
                                      { staticClass: "tag-row" },
                                      [
                                        _vm.activePatientInfo.label
                                          ? _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "primary",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-s-order",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.activePatientInfo
                                                        .label
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.activePatientInfo.patientRemark
                                          ? _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "info",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-edit-outline",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.activePatientInfo
                                                        .patientRemark
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                            _c("div", { staticClass: "header-right" }, [
                              _c(
                                "div",
                                { staticClass: "info-line info-with-action" },
                                [
                                  _c("div", { staticClass: "info-group" }, [
                                    _c(
                                      "span",
                                      { staticClass: "info-item" },
                                      [
                                        _c("label", [_vm._v("出生日期：")]),
                                        _c("value", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.activePatientInfo.birthDate ||
                                                "未知"
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c("span", { staticClass: "divider" }, [
                                      _vm._v("|"),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "info-item" },
                                      [
                                        _c("label", [_vm._v("就诊状态：")]),
                                        _c(
                                          "value",
                                          {
                                            class:
                                              "state-" +
                                              _vm.activeDiagRecord.diagRecord
                                                .stateSign,
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getStateText(
                                                    _vm.activeDiagRecord
                                                      .diagRecord.stateSign
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("span", { staticClass: "divider" }, [
                                      _vm._v("|"),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "info-item" },
                                      [
                                        _c("label", [_vm._v("病历号：")]),
                                        _c("value", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.activeDiagRecord.diagRecord
                                                .code || "-"
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "switch-btn",
                                      attrs: {
                                        size: "small",
                                        type: "primary",
                                        icon: "el-icon-refresh",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.cardShow = !_vm.cardShow
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.cardShow ? "历史记录" : "诊断开方"
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "info-line secondary-line" },
                                [
                                  _vm.activePatientInfo.contactAddress
                                    ? _c(
                                        "span",
                                        { staticClass: "info-item" },
                                        [
                                          _c("label", [_vm._v("地址：")]),
                                          _c("value", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.activePatientInfo
                                                  .contactAddress
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _c("span", {
                                        staticClass: "placeholder",
                                      }),
                                ]
                              ),
                            ]),
                          ]),
                        ],
                      ],
                      2
                    ),
                    _vm.cardShow
                      ? _c(
                          "el-card",
                          { staticClass: "treatment-body-card" },
                          [
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "flex flex-row justify-between",
                                  staticStyle: { "margin-bottom": "10px" },
                                },
                                [
                                  _c("div"),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-row align-center",
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                ["1"].indexOf(
                                                  _vm.activeDiagRecord
                                                    .diagRecord.stateSign
                                                ) > -1,
                                              expression:
                                                "['1'].indexOf( activeDiagRecord.diagRecord.stateSign)>-1",
                                            },
                                          ],
                                          attrs: {
                                            size: "mini",
                                            type: "success",
                                            icon: "el-icon-microphone",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.voiceConsultationVisible = true
                                            },
                                          },
                                        },
                                        [_vm._v("语音问诊")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                ["1"].indexOf(
                                                  _vm.activeDiagRecord
                                                    .diagRecord.stateSign
                                                ) > -1,
                                              expression:
                                                "['1'].indexOf( activeDiagRecord.diagRecord.stateSign)>-1",
                                            },
                                          ],
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: { click: _vm.handleTreatment },
                                        },
                                        [_vm._v("确认诊断")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                ["2"].indexOf(
                                                  _vm.activeDiagRecord
                                                    .diagRecord.stateSign
                                                ) > -1,
                                              expression:
                                                "['2'].indexOf( activeDiagRecord.diagRecord.stateSign)>-1",
                                            },
                                          ],
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: { click: _vm.prepareMed },
                                        },
                                        [_vm._v("确认处方 ")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                ["2", "3"].indexOf(
                                                  _vm.activeDiagRecord
                                                    .diagRecord.stateSign
                                                ) > -1,
                                              expression:
                                                "['2','3'].indexOf( activeDiagRecord.diagRecord.stateSign)>-1",
                                            },
                                          ],
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: { click: _vm.peiyao },
                                        },
                                        [_vm._v("配药 ")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.activeDiagRecord.diagRecord
                                                  .stateSign === "3",
                                              expression:
                                                "activeDiagRecord.diagRecord.stateSign==='3'",
                                            },
                                          ],
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: { click: _vm.pay },
                                        },
                                        [_vm._v("支付 ")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.activeDiagRecord.diagRecord
                                                  .stateSign === "4",
                                              expression:
                                                "activeDiagRecord.diagRecord.stateSign==='4'",
                                            },
                                          ],
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: { click: _vm.dispatchMed },
                                        },
                                        [_vm._v("发药 ")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                ["2"].indexOf(
                                                  _vm.activeDiagRecord
                                                    .diagRecord.stateSign
                                                ) > -1,
                                              expression:
                                                "['2'].indexOf( activeDiagRecord.diagRecord.stateSign)>-1",
                                            },
                                          ],
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: { click: _vm.resetDiag },
                                        },
                                        [_vm._v("重新诊断 ")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.activeDiagRecord.diagRecord
                                                  .stateSign === "4",
                                              expression:
                                                "activeDiagRecord.diagRecord.stateSign==='4'",
                                            },
                                          ],
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.printOpen()
                                            },
                                          },
                                        },
                                        [_vm._v(" 打印 ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            _c(
                              "div",
                              {
                                staticClass: "body flex flex-col",
                                staticStyle: {
                                  width: "100%",
                                  height: "calc(100% - 60px)",
                                  overflow: "auto",
                                },
                              },
                              [
                                _c("treatment-form", { ref: "treatmentForm" }),
                                _c("div", {
                                  staticClass: "divider-line w-full",
                                }),
                                _c("treatment-form2", {
                                  ref: "treatmentForm2",
                                }),
                                _c("div", {
                                  staticClass: "divider-line w-full",
                                }),
                                ["1"].indexOf(
                                  _vm.activeDiagRecord.treatmentRecord
                                    .executeSign
                                ) > -1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-row align-center flex",
                                        staticStyle: {
                                          width: "100%",
                                          "justify-content": "end",
                                        },
                                      },
                                      [
                                        _vm.currentTreatmentTab != 3 &&
                                        _vm.currentTreatmentTab != 2 &&
                                        _vm.currentTreatmentTab != 5
                                          ? _c(
                                              "tcm-rx2",
                                              {
                                                ref: "tcmRx2",
                                                staticClass: "mr-10",
                                                attrs: {
                                                  "search-key-word":
                                                    _vm.searchKeyWord,
                                                  url: "clinic/treatment/stdprescription/stdprescription",
                                                },
                                                on: {
                                                  show: _vm.handleShow,
                                                  onPopupClick:
                                                    _vm.handlePopupClick,
                                                  handleOpenClick:
                                                    _vm.handleOpenClick2,
                                                },
                                              },
                                              [_vm._v("搜索处方 ")]
                                            )
                                          : _vm._e(),
                                        _vm.currentTreatmentTab == 2
                                          ? _c(
                                              "TcmRxCPD2",
                                              {
                                                ref: "TcmRxCPD2Ref",
                                                staticClass: "mr-10",
                                                attrs: {
                                                  "search-key-word":
                                                    _vm.searchKeyWord,
                                                  url: "clinic/treatment/stdprescription/stdmedprescription",
                                                },
                                                on: {
                                                  show: _vm.handleShow,
                                                  onPopupClick:
                                                    _vm.handleMedicationSelect,
                                                  handleOpenClick:
                                                    _vm.handleCPDOpenClick,
                                                },
                                              },
                                              [_vm._v(" 搜索中成药 ")]
                                            )
                                          : _vm._e(),
                                        _vm.currentTreatmentTab != 3 &&
                                        _vm.currentTreatmentTab != 2 &&
                                        _vm.currentTreatmentTab != 5
                                          ? _c(
                                              "tcm-rx",
                                              {
                                                ref: "tcmRx",
                                                staticClass: "mr-10",
                                                attrs: {
                                                  "search-key-word":
                                                    _vm.searchKeyWord,
                                                  "ch-diag-content":
                                                    _vm.activeDiagRecord
                                                      .treatmentRecord
                                                      .chDiagContent,
                                                  "prescription-types-sign": 1,
                                                  url: "clinic/treatment/stdprescription/stdprescription",
                                                },
                                                on: {
                                                  show: _vm.handleShow,
                                                  onPopupClick:
                                                    _vm.handlePopupClick,
                                                  handleOpenClick:
                                                    _vm.handleOpenClick,
                                                },
                                              },
                                              [_vm._v("推荐处方 ")]
                                            )
                                          : _vm._e(),
                                        _vm.currentTreatmentTab == 2
                                          ? _c(
                                              "TcmRxCPD",
                                              {
                                                ref: "TcmRxCPDRef",
                                                staticClass: "mr-10",
                                                attrs: {
                                                  "search-key-word":
                                                    _vm.searchKeyWord,
                                                  "store-code": _vm.storeCode,
                                                  "diag-content":
                                                    _vm.activeDiagRecord
                                                      .treatmentRecord
                                                      .diagContent,
                                                  "ch-diag-content":
                                                    _vm.activeDiagRecord
                                                      .treatmentRecord
                                                      .chDiagContent,
                                                  "ch-yndrome-content":
                                                    _vm.activeDiagRecord
                                                      .treatmentRecord
                                                      .chYndromeContent,
                                                  "phy-content":
                                                    _vm.activeDiagRecord
                                                      .treatmentRecord
                                                      .phyContent,
                                                  "tab-content":
                                                    _vm.activeDiagRecord
                                                      .treatmentRecord
                                                      .tabContent || "",
                                                  url: "clinic/treatment/stdprescription/stdmedprescription",
                                                },
                                                on: {
                                                  show: _vm.handleShow,
                                                  onPopupClick:
                                                    _vm.handleMedicationSelect,
                                                  handleOpenClick:
                                                    _vm.handleCPDOpenClick,
                                                },
                                              },
                                              [_vm._v(" 中成药推荐 ")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "primary",
                                            },
                                            on: { click: _vm.saveChufang },
                                          },
                                          [_vm._v(" 保存处方 ")]
                                        ),
                                        _vm.currentTreatmentTab != 4 &&
                                        _vm.currentTreatmentTab != 5
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "primary",
                                                },
                                                on: {
                                                  click: _vm.clearPrescription,
                                                },
                                              },
                                              [_vm._v(" 清空处方 ")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c("treatment", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        ["1", "2", "3", "4"].indexOf(
                                          _vm.activeDiagRecord.diagRecord
                                            .stateSign
                                        ) > -1,
                                      expression:
                                        "['1','2','3','4'].indexOf( activeDiagRecord.diagRecord.stateSign)>-1",
                                    },
                                  ],
                                  ref: "treatment",
                                  on: {
                                    command: _vm.handleTreatmentCommand,
                                    "tab-change": _vm.handleTreatmentTabChange,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          2
                        )
                      : _c("el-card", { staticClass: "history-container" }, [
                          _c("div", { staticClass: "flex flex-row w-full" }, [
                            _c(
                              "div",
                              {
                                staticClass: "w-3/10 pr-4 history-section",
                                staticStyle: { width: "30%" },
                              },
                              [
                                _vm.activeDiagRecord.preTreatmentRecord !==
                                  null &&
                                _vm.activeDiagRecord.preTreatmentRecord !==
                                  undefined
                                  ? _c("div", [_c("pre-diag-record")], 1)
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "no-data flex flex-col w-full align-center justify-center",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "no-data-label" },
                                          [_vm._v("抱歉, 暂无相关数据")]
                                        ),
                                      ]
                                    ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "w-7/10 history-section",
                                staticStyle: { width: "100%", height: "70vh" },
                              },
                              [
                                _vm.hisTreatmentRecords.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "history-content" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "diagnosis-record-con",
                                          },
                                          [
                                            _c(
                                              "el-timeline",
                                              {
                                                staticClass: "history-timeline",
                                              },
                                              _vm._l(
                                                _vm.hisTreatmentRecords,
                                                function (record) {
                                                  return _c(
                                                    "el-timeline-item",
                                                    {
                                                      key: record.id,
                                                      attrs: {
                                                        type: "primary",
                                                      },
                                                    },
                                                    [
                                                      _c("diagnosis-record", {
                                                        staticClass: "record",
                                                        attrs: {
                                                          record: record,
                                                        },
                                                        on: {
                                                          command:
                                                            _vm.handleDiagnosisRecord,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "no-data flex flex-col w-full align-center justify-center",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "no-data-label" },
                                          [_vm._v("抱歉, 暂无相关数据")]
                                        ),
                                      ]
                                    ),
                              ]
                            ),
                          ]),
                        ]),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "no-patient-tip",
                    staticStyle: {
                      flex: "1",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center",
                      color: "#999",
                    },
                  },
                  [_vm._v(" 请从左侧选择一位病人开始诊疗 ")]
                ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: { title: "挂号", visible: _vm.enrollVisible },
          on: {
            "update:visible": function ($event) {
              _vm.enrollVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.enrollVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleEnroll },
                    },
                    [_vm._v("确认")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("enroll-form", {
            ref: "enrollForm",
            on: { command: _vm.handleEnrollCommand },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { modal: false, title: "配药", visible: _vm.prepareVisible },
          on: {
            "update:visible": function ($event) {
              _vm.prepareVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.resetDiag },
                    },
                    [_vm._v("重诊")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.pay },
                    },
                    [_vm._v("支付")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_c("prepare-med")],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { width: "479px", visible: _vm.payVisible, title: "支付结算" },
          on: {
            "update:visible": function ($event) {
              _vm.payVisible = $event
            },
          },
        },
        [_c("pay")],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "479px",
            "destroy-on-close": true,
            "show-close": false,
            modal: false,
            "custom-class": "qrcode-con",
            visible: _vm.qrcodeVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrcodeVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "flex flex-col align-center" }, [
            _c(
              "div",
              { staticClass: "flex flex-row align-center pay-header" },
              [
                _vm.payWay === "aliPay"
                  ? _c("img", {
                      staticClass: "icon-img",
                      attrs: {
                        src: require("@/assets/list/aliPay.png"),
                        alt: "",
                      },
                    })
                  : _vm._e(),
                _vm.payWay === "wechat"
                  ? _c("img", {
                      staticClass: "icon-img",
                      attrs: {
                        src: require("@/assets/list/wechat.png"),
                        alt: "",
                      },
                    })
                  : _vm._e(),
                _c("span", { staticClass: "tip" }, [
                  _vm._v(
                    "请使用" +
                      _vm._s(_vm._f("PAY_WAY")(_vm.payWay)) +
                      "扫码支付"
                  ),
                ]),
              ]
            ),
            _c("div", { ref: "qrcode" }),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "发药", visible: _vm.dispatchVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dispatchVisible = $event
            },
          },
        },
        [_c("dispatch-med")],
        1
      ),
      _c("whitePrescribeModal", { ref: "whitePrescribeModal" }),
      _c("video-call-dialog", {
        ref: "videoCallDialog",
        attrs: { "sdk-app-id": 1400539979 },
      }),
      _c("voice-consultation-modal", {
        attrs: { visible: _vm.voiceConsultationVisible },
        on: {
          "update:visible": function ($event) {
            _vm.voiceConsultationVisible = $event
          },
          complete: _vm.handleVoiceComplete,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }